export enum CompanySubRoute {
  Guides = 'guides',
  PreviewGuides = 'preview-guides',
  GuideFeatures = 'guide-features',
  Insights = 'insights',
  Contributors = 'contributors',
  Settings = 'settings',
  Profile = 'profile',
}
